import { render, staticRenderFns } from "./JsonDebug.vue?vue&type=template&id=616ac987&"
import script from "./JsonDebug.vue?vue&type=script&lang=js&"
export * from "./JsonDebug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports